import { ChoiceStore, GenericStore } from 'ui/base/input';

import { Optional } from 'services/base/types';

import {
  Invoice,
  Payment,
  PaymentMap,
  PlanFirewallBilling,
  PlanFirewallPackage,
} from 'services/accounts/types';

export type PlanItemFirewallStoreProps = {
  package: Optional<PlanFirewallPackage>;
  billing: Optional<PlanFirewallBilling>;
  payment_id: Optional<string>;
};

export class PlanItemFirewallStore {

  package_default: Optional<PlanFirewallPackage>;
  package_store: ChoiceStore<PlanFirewallPackage>;

  billing_default: Optional<PlanFirewallBilling>;
  billing_store: ChoiceStore<PlanFirewallBilling>;

  payment_default: Optional<string>;
  payment_store: ChoiceStore<Payment>;

  preview_is_trialing_store: GenericStore<boolean>;
  preview_trial_until_store: GenericStore<Optional<Date>>;
  preview_charges_store: GenericStore<Optional<Invoice[]>>;
  preview_refunds_store: GenericStore<Optional<Invoice[]>>;
  preview_notes_store: GenericStore<Optional<string[]>>;

  constructor(plan: Optional<PlanItemFirewallStoreProps>, payments: PaymentMap) {
    plan = plan ?? { package: undefined, billing: undefined, payment_id: undefined };

    this.package_default = plan.package;
    this.package_store = new ChoiceStore<PlanFirewallPackage>({
      [PlanFirewallPackage.BASIC]: PlanFirewallPackage.BASIC,
      [PlanFirewallPackage.BUSINESS]: PlanFirewallPackage.BUSINESS,
      [PlanFirewallPackage.ENTERPRISE]: PlanFirewallPackage.ENTERPRISE,
    }, this.package_default);

    this.billing_default = plan.billing;
    this.billing_store = new ChoiceStore<PlanFirewallBilling>({
      [PlanFirewallBilling.MONTHLY]: PlanFirewallBilling.MONTHLY,
      [PlanFirewallBilling.YEARLY]: PlanFirewallBilling.YEARLY,
      [PlanFirewallBilling.BIENNIAL]: PlanFirewallBilling.BIENNIAL,
      [PlanFirewallBilling.TRIENNIAL]: PlanFirewallBilling.TRIENNIAL,
      [PlanFirewallBilling.LIFETIME]: PlanFirewallBilling.LIFETIME,
    }, this.billing_default);

    this.payment_default = plan.payment_id;
    this.payment_store = new ChoiceStore<Payment>(
      payments.reduce<Record<string, Payment>>(
        (payments, payment, payment_id) => {
          payments[payment_id] = payment;
          return payments;
        }, {}
      ), this.payment_default
    );

    this.preview_is_trialing_store = new GenericStore(false);
    this.preview_trial_until_store = new GenericStore(undefined);
    this.preview_charges_store = new GenericStore(undefined);
    this.preview_refunds_store = new GenericStore(undefined);
    this.preview_notes_store = new GenericStore(undefined);
  }

}
